// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as ArrowLeftDefault } from '../../../assets/icons/default/arrows/arrow-left.svg?react';
import { ReactComponent as ArrowLeftSolid } from '../../../assets/icons/solid/arrows/ARROW-LEFT.svg?react';
import { createIcons } from '../../Icon';
const ArrowLeftIcon = /* @__PURE__ */ createIcons('ArrowLeft', {
    default: ArrowLeftDefault,
    solid: ArrowLeftSolid
});
ArrowLeftIcon.supportedTypes = ['default', 'solid'];
ArrowLeftIcon.category = 'arrows';
export default ArrowLeftIcon;
